export default __webpack_public_path__ + "static/statenov-078d5e1de8247823dbcc8142c4f66f80.jpg";